import type { IconProps } from '../types/IconProps.ts';
export const Frown: IconProps = {
    name: 'Frown',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<circle cx="8" cy="10" r=".5" />`,
        `<circle cx="16" cy="10" r=".5" />`,
        `<path d="M8 16a4.6 4.6 0 0 1 8 0" />`,
    ]
};